import React from "react";
import Svg, { Path, G, Rect, Defs, ClipPath } from "react-native-svg";
import { TouchableOpacity } from "react-native";
import AppTheme from "../../../AppTheme";

export default function ElementSmileyIcon(props) {
  const width = props.width || 30;
  const height = props.height || 30;
  const color = props.color || "#DDDAD5";

  return (
    <TouchableOpacity {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip_smiley)">
          <Path
            d="M15 0C12.0333 0 9.13319 0.879735 6.66645 2.52796C4.19972 4.17618 2.27713 6.51886 1.14181 9.25975C0.00649929 12.0006 -0.290551 15.0166 0.288228 17.9264C0.867006 20.8361 2.29562 23.5088 4.39341 25.6066C6.49119 27.7044 9.16394 29.133 12.0737 29.7118C14.9834 30.2906 17.9994 29.9935 20.7403 28.8582C23.4812 27.7229 25.8238 25.8003 27.4721 23.3336C29.1203 20.8668 30 17.9667 30 15C30 11.0218 28.4197 7.20644 25.6066 4.3934C22.7936 1.58035 18.9783 0 15 0V0ZM7.50001 13.125C7.50001 12.7542 7.60997 12.3916 7.816 12.0833C8.02203 11.775 8.31486 11.5346 8.65748 11.3927C9.00009 11.2508 9.37709 11.2137 9.7408 11.286C10.1045 11.3584 10.4386 11.537 10.7008 11.7992C10.9631 12.0614 11.1416 12.3955 11.214 12.7592C11.2863 13.1229 11.2492 13.4999 11.1073 13.8425C10.9654 14.1851 10.725 14.478 10.4167 14.684C10.1084 14.89 9.74585 15 9.37501 15C8.87773 15 8.40081 14.8025 8.04918 14.4508C7.69755 14.0992 7.50001 13.6223 7.50001 13.125ZM15 23.75C13.6739 23.75 12.4022 23.2232 11.4645 22.2855C10.5268 21.3479 10 20.0761 10 18.75H12.5C12.5 19.413 12.7634 20.0489 13.2322 20.5178C13.7011 20.9866 14.337 21.25 15 21.25C15.663 21.25 16.2989 20.9866 16.7678 20.5178C17.2366 20.0489 17.5 19.413 17.5 18.75H20C20 20.0761 19.4732 21.3479 18.5355 22.2855C17.5979 23.2232 16.3261 23.75 15 23.75ZM20.625 15C20.2542 15 19.8917 14.89 19.5833 14.684C19.275 14.478 19.0346 14.1851 18.8927 13.8425C18.7508 13.4999 18.7137 13.1229 18.786 12.7592C18.8584 12.3955 19.037 12.0614 19.2992 11.7992C19.5614 11.537 19.8955 11.3584 20.2592 11.286C20.6229 11.2137 20.9999 11.2508 21.3425 11.3927C21.6851 11.5346 21.978 11.775 22.184 12.0833C22.39 12.3916 22.5 12.7542 22.5 13.125C22.5 13.6223 22.3025 14.0992 21.9508 14.4508C21.5992 14.8025 21.1223 15 20.625 15Z"
            fill={color}
          />
        </G>
        <Defs>
          <ClipPath id="clip_smiley">
            <Rect width="30" height="30" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
